import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import SalesChannelForm from './SalesChannelForm';

const SalesChannels = () => {
	const defaultSort = useMemo(() => [{ id: 'id', desc: false }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'id',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'logo',
				accessor: 'salesChannelLogo',
				filterType: FilterType.string,
				renderCell: ListComponents.SALES_CHANNEL_LOGO
			},
			{
				Header: 'name',
				accessor: 'name',
				filterType: FilterType.string
			},
			{
				Header: 'slug',
				accessor: 'slug',
				filterType: FilterType.string
			},
			{
				Header: 'showOnOto',
				accessor: 'showOnOto',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'syncOrders',
				accessor: 'syncOrders',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				show: false
			},
			{
				Header: 'syncProducts',
				accessor: 'syncProducts',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				show: false
			},
			{
				Header: 'storeLocation',
				accessor: 'storeLocation',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				show: false
			},
			{
				Header: 'statusMapping',
				accessor: 'statusMapping',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				show: false
			},
			{
				Header: 'testable',
				accessor: 'testable',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				show: false
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string
			},
			{
				Header: 'formName',
				accessor: 'formName',
				filterType: FilterType.string
			},
			{
				Header: 'formType',
				accessor: 'formType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.SALES_CHANNELS_FORMS
			},
			{
				Header: 'integrationName',
				accessor: 'integrationName',
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				title="salesChannels"
				lordIcon="https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shippingPartners-icon-new.json.gz">
				<Authorization path="/modal/add-sales-channel">
					<Button
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						label="addSalesChannel"
						onClick={() => NiceModal.show(SalesChannelForm, { mode: 'create' })}
						variant="blue"
						className="addButton"
					/>
				</Authorization>
			</PageHeader>
			<DynamicList
				id={DYNAMICLISTS.ADMIN_SALES_CHANNELS}
				columns={columns}
				fetchUrl={ADMIN.SALES_CHANNELS.GET_LIST}
				exportName="salesChannels"
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
			/>
		</div>
	);
};

export default SalesChannels;
